export function sanitizeInjectionMoldingPartNumberSuffix(value: string): string {
    return value
        .replace(/ /g, '-')
        .replace(/a/gi, 'A')
        .replace(/[^0-9A-]/g, '');
}
